type Middleware = (...arg: any) => any

export function composeMiddleware<T>(middlewareList: (T & Middleware)[] = [], params: any) {
  const firstMiddleware = middlewareList[0]
  const lastIndex = middlewareList.length - 1
  const lastMiddleware = middlewareList[lastIndex]
  if (middlewareList.length === 1) return firstMiddleware(params)
  const initialReduceResult = lastMiddleware(params)
  return middlewareList.reduceRight((res, item, index) => {
    if (index === lastIndex) {
      return initialReduceResult
    }
    return item(res)
  }, null)
}
